import { Component, h } from 'preact'
import axios from 'axios'
import { EmailTemplateEdit } from './EmailTemplateEdit'

type Props = {
  emailTemplateId: number,
}

type State = {
  emailTemplateId: number | null,
  content: string,
  alertMessage: string,
  alertMessageType: null | string,
}

class EmailTemplateEditContainer extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      emailTemplateId: props.emailTemplateId || null,
      content: '',
      alertMessage: '',
      alertMessageType: null
    }
    this.onSaveChanges = this.onSaveChanges.bind(this)
    this.onContentChange = this.onContentChange.bind(this)
    this.hideAlertMessage = this.hideAlertMessage.bind(this)
  }

  async componentDidMount () {
    const { emailTemplateId } = this.state
    try {
      const response = await axios.get(`/emailTemplate/find/${emailTemplateId}`)
      this.setState({
        content: response.data.Content
      })
    } catch {
      this.setState({
        alertMessageType: 'error',
        alertMessage: 'Something went wrong, please try again later.'
      })
    }
  }

  onContentChange (html: string) {
    this.setState({ content: html })
  }

  async onSaveChanges () {
    const { emailTemplateId, content } = this.state

    if (!content.includes('{content}') || !content.includes('{unsubscribeUrl}')) {
      this.setState({
        alertMessageType: 'error',
        alertMessage: 'Please include {content} tag and {unsubscribeUrl} tag in your template'
      })
      return
    }

    try {
      await axios.post('/emailTemplate/save', {
        emailTemplateId,
        content
      })
      this.setState({
        alertMessageType: 'success',
        alertMessage: 'All changes saved successfully!'
      })
    } catch {
      this.setState({
        alertMessageType: 'error',
        alertMessage: ''
      })
    }
  }

  hideAlertMessage () {
    this.setState({ alertMessageType: null, alertMessage: '' })
  }

  render (_: Props, { content, alertMessageType, alertMessage }: State) {
    return (
      <EmailTemplateEdit
        content={content}
        alertMessage={alertMessage}
        alertMessageType={alertMessageType}
        onSaveChanges={this.onSaveChanges}
        hideAlertMessage={this.hideAlertMessage}
        onContentChange={this.onContentChange}
      />
    )
  }
}

export default EmailTemplateEditContainer
